import React from 'react';
import goodnation from '../assets/images/goodnation-circle.png';

function GoodNation() {
    return (
        <a href="https://www.goodnation.io/"><img src={goodnation} className="goodnation" alt="GoodNation Partner" /></a>
    )
}

export default GoodNation;